module.exports = __webpack_public_path__ + "static/media/paperPin.79e3214c.png";